import { useTranslations } from 'next-intl';
import { ModalPortal } from '@/components/layout/modals/ModalPortal';
import { Button } from '@/components/ui/button/Button';
import { PATHS } from '@/constants/path';
import { useRouter } from '@/i18n/routing';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  /** 主ボタン押下時の遷移を上書きする。未指定ならトップページへ戻る。 */
  onPrimaryAction?: () => void;
};

export const MigrationThankYouModal = ({ isOpen, onClose, onPrimaryAction }: Props) => {
  const t = useTranslations();
  const { push } = useRouter();

  const handleClick = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
      return;
    }
    onClose();
    push(PATHS.ROOT);
  };

  return (
    <ModalPortal
      isOpen={isOpen}
      onClose={onClose}
      cancelable
      title={t('procedure_completed_thank_you')}
      body={t('procedure_completed_message')}
      PrimaryButtonComponent={() => (
        <Button label={t('common-back_to_top')} fullWidth onClick={handleClick} />
      )}
    />
  );
};
